// components/TableSummaryRow.tsx
import React from 'react'
import classnames from 'classnames'

type TableSummaryRowProps = {
    cells: React.ReactNode[]
    rowClassName?: string
    cellClassName?: (index: number, isLast: boolean) => string
}

export const TableSummaryRow: React.FC<TableSummaryRowProps> = ({
    cells,
    rowClassName,
    cellClassName = (idx, isLast) =>
        classnames('px-4 py-3 bg-neutral-200 font-bold', {
            'sticky left-0 z-10': idx === 0,
            'border-r border-neutral-300': !isLast,
            'rounded-bl-xl': idx === 0,
            'rounded-br-xl': isLast,
        }),
}) => {
    return (
        <tfoot className="sticky bottom-0 z-30" data-testid="table-summary-row">
            <tr
                className={classnames(
                    'bg-neutral-200 text-sm font-normal not-italic text-neutral-900',
                    rowClassName
                )}
            >
                {cells.map((cell, idx) => {
                    const isLast = idx === cells.length - 1
                    return (
                        <td key={idx} className={cellClassName(idx, isLast)}>
                            {cell}
                        </td>
                    )
                })}
            </tr>
        </tfoot>
    )
}
